import { FormGroup, FormParagraph } from '@ksyos/design-system';
import { DiaryTypes } from '@common/enums';
import { ProcessActivityReadContext } from '@frontend/components/pages/episodeCategory/carePath/process/processActivity/processActivityRead/processActivityReadContext';
import { useDefinedContext } from '@frontend/utils/hooks/useDefinedContext';
import { ProcessActivityAssetsRead } from '../../../processActivityAssets/ProcessActivityAssetsRead';

export function HolterDiaryUploadRead(): JSX.Element {
    const { processActivity } = useDefinedContext(ProcessActivityReadContext);

    if (processActivity.customControlData.diaryType === DiaryTypes.paperUpload) {
        return (
            <ProcessActivityAssetsRead
                assets={processActivity.customControlData.assets}
                label="Dagboek"
            />
        );
    }

    if (processActivity.customControlData.diaryType === DiaryTypes.none) {
        return (
            <FormGroup label="Dagboek">
                <FormParagraph>Dagboek ontbreekt</FormParagraph>
            </FormGroup>
        );
    }

    return <></>;
}
